const  sampleData = () => {
  return([
    {
        year: 'Jan-2016',
        details: 'FAIR',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Jan-2016',
        details: 'TRAVEL',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Feb-2016',
        details: 'LUNCH',
        fees: 200,
        total_count: 20,
        dr: null,
        cr: 40,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Feb-2016',
        details: 'DINNER',
        fees: 200,
        total_count: 20,
        dr: null,
        cr: 40,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Jun-2016',
        details: 'TICKET',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Sep-2016',
        details: 'OFFICIAL',
        fees: 200,
        total_count: 20,
        dr: null,
        cr: 40,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Oct-2016',
        details: 'INSURANCE',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Dec-2016',
        details: 'RENTS',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Jan-2017',
        details: 'SALARY',
        fees: 200,
        total_count: 20,
        dr: null,
        cr: 40,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Feb-2017',
        details: 'DEBT',
        fees: 200,
        total_count: 20,
        dr: null,
        cr: 40,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Feb-2017',
        details: 'EXPENSE',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Mar-2017',
        details: 10,
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: 40,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Mar-2017',
        details: 'AMENITIES',
        fees: 200,
        total_count: 20,
        dr: null,
        cr: 40,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Apr-2017',
        details: 'FURNITURE',
        fees: 200,
        total_count: 20,
        dr: null,
        cr: 40,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Jan-2018',
        details: 'SETTELEMENT',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Aug-2018',
        details: 'BANK',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null,
        bal: 4500,
        credit_limit: 2000
    },
    {
        year: 'Nov-2018',
        details: 'ELECTRIC',
        fees: 200,
        total_count: 20,
        dr: 30,
        cr: null
        ,
        bal: 4500,
        credit_limit: 2000
    },

]
);
}
export default sampleData;